<template>
    <div id="special" class="p-lp__special">
        <div class="c-wave-mv c-wave-mv--special">
            <div class="c-wave-mv__bg">
                <picture>
                    <source media="(max-width: 800px)" srcset="/specialoffer/assets/img/specialoffer/special/mv-sp.jpg">
                    <img src="/specialoffer/assets/img/specialoffer/special/mv-pc.jpg" alt="" width="1440" height="720">
                </picture>
            </div>
            <div class="c-wave-mv__content">
                <div class="content">
                    <img class="c-wave-mv__icon" src="/specialoffer/assets/img/specialoffer/special/icon-down.png" alt="" width="126" height="126">
                    <h2>
                        <span class="en">SPECIAL OFFER</span>
                        <span class="ja">モデルハウス特別販売</span>
                        <span class="sub">展示の家具・インテリア装備の物件を<br>セレクトしました！</span>
                    </h2>
                </div>
            </div>
        </div>

        <!-- 物件一覧 -->
        <div class="c-special-list">
          <div class="c-special-list__equipment">
            <h2>物件共通の設備</h2>
            <ul>
              <li>明暗センサー</li>
              <li>テレビドアホン</li>
              <li>一階 電動シャッター</li>
              <li>防犯ガラス（シャッターの無い窓）</li>
              <li>玄関電気錠</li>
              <li>アルミ樹脂断熱差サッシ</li>
              <li>食洗機</li>
            </ul>
          </div>

          <div class="c-special-list__property">
            <!-- 物件 -->
            <div class="c-propertyBox" v-for="(property, i) in propertyList" :key="i">
              <div class="c-propertyBox__content">
                <span class="tag">{{ property.place }}</span>
                <h3>
                  {{ property.title }}<br><span v-html="property.area"></span>
                </h3>
                <h4 v-html="property.subtitle"></h4>
                <p v-html="property.comment"></p>
                <ul>
                  <li v-for="(equipment, x) in property.equipment" :key="x">{{ equipment }}</li>
                </ul>

                <div class="c-propertyBox__content__equipment">
                  <p>{{ property.equipment2 }}</p>
                </div>

                <div v-if="!property.sold" class="c-propertyBox__content__btn">
                  <p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                      <path d="M5.00817 6.91003L1.32483 3.22669C0.876223 2.77808 0.776112 2.26478 1.0245 1.68678C1.27195 1.10783 1.71442 0.818359 2.35192 0.818359H9.64775C10.2852 0.818359 10.7277 1.10783 10.9752 1.68678C11.2236 2.26478 11.1234 2.77808 10.6748 3.22669L6.9915 6.91003C6.84983 7.05169 6.69636 7.15794 6.53108 7.22878C6.36581 7.29961 6.18872 7.33503 5.99983 7.33503C5.81095 7.33503 5.63386 7.29961 5.46858 7.22878C5.30331 7.15794 5.14983 7.05169 5.00817 6.91003Z" fill="#275231"/>
                    </svg>
                    月々の支払いや入居時期を今すぐ確認！
                  </p>
                  <a class="c-btn c-btn--now c-btn--shadow" href="#" target="_blank" @click.prevent="selectProperty(getListName(property))">今すぐ無料相談</a>
                </div>
                <div v-if="property.sold" class="c-propertyBox__content__sold">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M29.73 13.4542L21.2476 8.3484C20.475 7.88387 19.5269 7.88387 18.7544 8.3484L10.2739 13.4542C9.48577 13.929 9 14.8148 9 15.7727V29.7109C9 31.185 10.1296 32.3784 11.5205 32.3784H14.5912C16.0173 32.3784 17.1742 31.1541 17.1742 29.6448V24.8921C17.1742 24.0725 17.8023 23.4077 18.5768 23.4077H21.4232C22.1977 23.4077 22.8258 24.0725 22.8258 24.8921V29.6448C22.8258 31.1541 23.9827 32.3784 25.4088 32.3784H28.4795C29.8724 32.3784 31 31.183 31 29.7109V15.7727C31 14.8127 30.5142 13.927 29.7261 13.4542H29.73Z" fill="white"/>
                </svg>
                  <p>
                    ご成約済み
                  </p>
                </div>
              </div>

              <div class="c-propertyBox__photos">
                <div class="c-propertyBox__photos__img">
                  <img :src="property.image[0]" alt="" width="398" height="240">
                  <img :src="property.image[1]" alt="" width="398" height="240">
                  <img v-if="property.image[2]" :src="property.image[2]" alt="" width="398" height="240">
                </div>
                <div class="c-propertyBox__photos__pdf">
                  <a class="link-pdf" :href="property.pdf.url" target="_blank">
                    <img :src="property.pdf.image" alt="" width="312" height="496">
                    <span></span>
                  </a>
                  <a class="link-external" :href="property.link" target="_blank">
                    <span>物件詳細を見る</span>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import store from '@/_modules/store';

export default {
  data() {
    return {
        isLoaded: false,
        propertyList: [],
        propertyNameList: [],
    }
  },
  mounted() {
    axios.get(`/specialoffer/bukken/bukken.json?ts=${new Date().getTime()}`)
    .then(this.getJson)
    .catch(this.error);
  },
  methods: {
    getJson(res) {
        this.propertyList = res.data;
        this.isLoaded = true;

        this.propertyNameList = [];
        this.propertyList.forEach((property) => {
          if (property.sold === false) {
            this.propertyNameList.push(this.getListName(property));
          }
        });

        this.$store.commit('propertyList', this.propertyNameList);
    },
    getListName(property) {
      return `${property.title} ${property.area.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')} ${property.buildingNumber}`;
    },
    selectProperty(value) {
        this.$store.commit('selectProperty', value);
    },
    error(err) {
        console.log(err);
    }
  }
}

</script>